













































































import { Component, Mixins, Prop, VModel } from 'vue-property-decorator';

import ModelSetter from "../../../../../Mixins/ModelSetter";
import { SelectOption } from "../../../../../logic/types";
import {
  ChannelInfo,
  ErrorChannelInfo,
  SuccessChannelInfo
} from "../../../../../models/CheckChannels/CheckChannels";
import ConfigField from "../../../../ConfigField/ConfigField.vue";
import ChannelsInfoHelper from "../../../../Flow/new/logic/Helpers/ChannelsInfoHelper";
import NumberInput from '../../../../Pi/fields/NumberInput/NumberInput.vue';
import SelectInput from "../../../../Pi/fields/SelectInput/SelectInput.vue";
import TargetCard from "../../../../TargetCard/TargetCard.vue";
import { TargetCardInfo } from "../../../../TargetCard/types";
import { BoostsConditionModeEnum } from "../../types";
import { BoostsCondition } from "../types";

@Component({
  components: {
    ConfigField,
    TargetCard,
    NumberInput,
    SelectInput
  }
})
export default class DistributionBoostsCondition extends Mixins(ModelSetter) {
  @VModel() condition!: BoostsCondition

  @Prop({ type: Boolean, default: false }) disabled!: boolean

  @Prop() getChannelsInfo!: (targets: Array<string | number>) => Promise<Array<ChannelInfo>>

  @Prop({ type: Array, default: () => [] }) targets!: Array<SelectOption>

  targetId = ''

  bindedTarget: TargetCardInfo | null = null

  get isAddTargetDisabled() {
    return this.disabled || !this.targetId
  }

  get filteredTargets() {
    return this.targets.filter(t => !this.targets.includes(t.value))
  }

  get boostsModeOptions(): Array<SelectOption> {
    return [
      {
        label: this.$t(`distribution_condition_mode_${ BoostsConditionModeEnum.Equals.toLowerCase() }`).toString(),
        value: BoostsConditionModeEnum.Equals
      },
      {
        label: this.$t(`distribution_condition_mode_${ BoostsConditionModeEnum.Greater.toLowerCase() }`).toString(),
        value: BoostsConditionModeEnum.Greater
      },
      {
        label: this.$t(`distribution_condition_mode_${ BoostsConditionModeEnum.Less.toLowerCase() }`).toString(),
        value: BoostsConditionModeEnum.Less
      },
    ]
  }

  setBindedTarget(target: ChannelInfo) {
    const isSuccessChannelInfo = target instanceof SuccessChannelInfo

      this.bindedTarget = {
      type: isSuccessChannelInfo ? target.info.type.toLowerCase().toString() : null,
      id: isSuccessChannelInfo ? target?.info?.id : target?.value,
      title: isSuccessChannelInfo ? target?.info?.title : null,
        login: isSuccessChannelInfo ? target?.info?.login ?? null : null,
        error: target instanceof ErrorChannelInfo ? target.error : null,
    }
  }

  setTargetId(target: ChannelInfo) {
    if (target instanceof SuccessChannelInfo) {
      this.condition.target_id = target.info.id
    } else {
      this.condition.target_id = null
    }
  }

  addTarget(value?: string) {
    const trimmedTargetValue = value?.trim() ?? this.targetId.trim()
    const cachedTarget = ChannelsInfoHelper.GetChannel(trimmedTargetValue)

    if (cachedTarget) {
      this.setBindedTarget(cachedTarget)

      this.targetId = ''

      this.setTargetId(cachedTarget)
    } else {
      this.getChannelsInfo([ trimmedTargetValue ])
        .then(res => {
          if (res && res.length) {
            const target = res[0]

            if (target instanceof SuccessChannelInfo) {
              ChannelsInfoHelper.Channels.unshift(...res)
            }

            this.setTargetId(target)
            this.setBindedTarget(target)
          }

          this.targetId = ''
        })

    }

  }

  selectOption(value: string) {
    this.addTarget(value)
  }

  created() {
    if (this.condition.target_id) {
      this.addTarget(this.condition.target_id.toString())
    }
  }
}
